function topicToHtml(elem, childrenHtml) {
  return `<span data-w-e-type='topic' style="color: #2695f1">${childrenHtml}</span>`;
}

export const topicToHtmlConf = {
  type: 'topic',
  elemToHtml: topicToHtml,
};
